import * as React from 'react'

import { observer } from 'mobx-react'

import RestrictionMessages from '~/client/src/shared/components/RestrictionMessages/RestrictionMessages'
import Localization from '~/client/src/shared/localization/LocalizationManager'

// localization: translated

interface IProps {
  isChanged: boolean

  validationMessage?: string
  validationMessages?: string[]
  additionalHelperText?: string
  isValid?: boolean
  isCondensed?: boolean
  isHiddenWhenEmpty?: boolean
}

@observer
export default class StruxhubInputHelperText extends React.PureComponent<IProps> {
  public render() {
    const {
      isChanged,
      isValid,
      validationMessage,
      additionalHelperText,
      isCondensed = false,
      isHiddenWhenEmpty = false,
      validationMessages,
    } = this.props

    const helperText = []
    const validationText = []

    if (isChanged) {
      validationText.push(Localization.translator.changed)
    }
    if (!isValid && validationMessage && !validationMessages?.length) {
      validationText.push(validationMessage)
    }
    if (!isValid && validationMessages?.length && !validationMessage) {
      validationText.push(...validationMessages)
    }
    if (additionalHelperText) {
      helperText.push(additionalHelperText)
    }

    if (isHiddenWhenEmpty && !validationText.length && !helperText.length) {
      return null
    }

    if (validationMessages?.length) {
      return (
        <RestrictionMessages
          messages={validationText}
          className="px8"
          messageClassName="min-height16 line-16 text red"
        />
      )
    }

    if (validationText.length) {
      return (
        <div
          className={`px8 ${!isCondensed && 'min-height16 line-16'} text red`}
        >
          {validationText.join(' + ')}
        </div>
      )
    }

    return (
      <div
        className={`px8 ${!isCondensed && 'min-height16 line-16'} text light`}
      >
        {helperText.join(' + ')}
      </div>
    )
  }
}
